export default __webpack_public_path__ + "static/works_4-60fc3174d13a26e1cac379c4abb07dfe.png";